import { useQuery } from '@tanstack/react-query';

import { CameraVersionsService } from '../services';
import { useFleet, useHasPermission } from '../hooks';
import { queryClient } from '../components/queryClient';

export const useCameraVersions = () => {
  const fleet = useFleet();
  const queryKey = ['cameraVersions'];
  const hasPermission = useHasPermission('devices:read:list');

  const queryFn = () => CameraVersionsService.getCameraVersions();

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && hasPermission,
  });
};

export const refreshCameraVersions = () => {
  queryClient.invalidateQueries(['cameraVersions']);
};
